export default __webpack_public_path__ + "static/media/money-bag.e79df3b2.png";